module.exports = __webpack_public_path__ + "static/media/cne.90cbe13d.jpg";